module.exports = __webpack_public_path__ + "static/media/Saas.b4316516.png";